import api from "../../../services/api";

export const deleteUser = async (username: string) => {
  const { data } = await api.delete(`/api/cognito/admin/users/${encodeURIComponent(username)}`);
  return data;
};